/**
 * Central configuration file for the Boat Tracker frontend application
 */

// Backend server URL options (uncomment the one you want to use)
// For local development on same machine
// export const BACKEND_URL = 'http://localhost:5000';
// For accessing from mobile devices on same network
// export const BACKEND_URL = 'http://192.168.142.1:5000';
// For accessing from Google Cloud instance
// export const BACKEND_URL = 'http://34.131.63.26:5000';
// For accessing from AWS EC2 instance
// export const BACKEND_URL = 'http://65.0.175.211:5000';
// For accessing from AWS EC2 instance with HTTPS
// export const BACKEND_URL = 'https://65.0.175.211:5443';

// Backend URL configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://65.0.175.211:5000';

// Google Maps API key
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyA6wWF47cejmrwic65drmPiOIhrawrYnzw';

/**
 * Additional configuration settings for the app
 */
export const APP_CONFIG = {
  // Default map center (India)
  defaultMapCenter: { lat: 20.5937, lng: 78.9629 },
  defaultZoom: 5,
  
  // Map view settings
  mapSettings: {
    showLabels: true,
    enableClustering: true,
    maxZoom: 18,
    minZoom: 3
  },
  
  // Location tracking settings
  tracking: {
    updateFrequency: 5000, // milliseconds
    enableHighAccuracy: true,
    timeout: 5000
  }
};

export default {
  BACKEND_URL,
  APP_CONFIG
}; 